<template>
  <v-container id="regular-forms" fluid tag="section">
    <v-row>
      <v-col cols="12">
        <base-material-card
          color="primary"
          icon="mdi-account"
          :title="
            $route.params.id ? $t('Edit Typecategory') : $t('New Typecategory')
          "
          class="px-5 py-3"
        >
          <v-progress-linear
            indeterminate
            rounded
            height="6"
            v-if="loading"
          ></v-progress-linear>
          <v-form
            v-else
            ref="form"
            autocomplete="new-password"
            lazy-validation
            @submit.prevent="saveItem"
          >
            <v-text-field
              v-model="formValues.name"
              label="Name"
              v-validate="'required'"
              required
              data-vv-name="name"
              :error-messages="errors.collect('name')"
            ></v-text-field>
            <v-text-field
              v-model="formValues.name_it"
              label="Name IT"
              v-validate="'required'"
              required
              data-vv-name="name_it"
              :error-messages="errors.collect('name_it')"
            ></v-text-field>
            <v-checkbox
              v-model="formValues.has_edge_spacers"
              :label="$t('edge_spacer')"
              v-validate=""
              data-vv-name="has_edge_spacers"
              :error-messages="errors.collect('has_edge_spacers')"
            ></v-checkbox>
            <v-checkbox
              v-model="formValues.has_system1"
              :label="$t('has_system1')"
              v-validate=""
              data-vv-name="has_system1"
              :error-messages="errors.collect('has_system1')"
            ></v-checkbox>
            <v-select
              v-model="formValues.color"
              :items="colors"
              label="Farbe"
              item-text="name"
              item-value="id"
              v-validate="''"
              data-vv-name="colors"
              :error-messages="errors.collect('colors')"
            ></v-select>

            <v-card color="#eee" class="pa-2">
              <v-row>
                <v-col>
                  <h3>{{ $t("certificates") }}</h3>
                  <hr />
                  <v-checkbox
                    v-model="formValues.has_conformity"
                    :label="$t('has_conformity')"
                    v-validate=""
                    data-vv-name="has_conformity"
                    :error-messages="errors.collect('has_conformity')"
                  ></v-checkbox>
                  <v-checkbox
                    v-model="formValues.has_ce_heat"
                    :label="$t('has_ce_heat')"
                    v-validate=""
                    data-vv-name="has_ce_heat"
                    :error-messages="errors.collect('has_ce_heat')"
                  ></v-checkbox>
                  <v-checkbox
                    v-model="formValues.has_performance"
                    :label="$t('has_performance')"
                    v-validate=""
                    data-vv-name="has_performance"
                    :error-messages="errors.collect('has_performance')"
                  ></v-checkbox>
                  <v-checkbox
                    v-model="formValues.has_ce"
                    :label="$t('has_ce')"
                    v-validate=""
                    data-vv-name="has_ce"
                    :error-messages="errors.collect('has_ce')"
                  ></v-checkbox>
                </v-col> </v-row
            ></v-card>
            <v-card-actions class="pl-0">
              <v-btn
                color="primary"
                class="mr-4"
                @click="$router.push({ name: 'typeCategory.index' })"
              >
                {{ $t("back") }}
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn color="primary" class="mr-4" @click="saveItem">
                {{ $t("save") }}
              </v-btn>
            </v-card-actions>
          </v-form>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { saveItem, fetchItem } from "../shared/services";
export default {
  name: "app-typeCategory-item",
  $_veeValidate: {
    validator: "new"
  },
  data() {
    return {
      formValues: {},
      loading: true,
      colors: [
        { name: "-", id: null },
        { name: "Grün", id: "green" },
        { name: "Blau", id: "blue" },
        { name: "Rot", id: "red" },
        { name: "Grau", id: "grey" }
      ]
    };
  },
  mounted() {
    if (this.$route.params.id) {
      this.loading = true;
      fetchItem(this.$route.params.id).then(res => {
        this.formValues = res.data;
        this.loading = false;
      });
    } else {
      this.loading = false;
    }
  },
  computed: {
    computedFormValues() {
      return {
        ...this.formValues
      };
    }
  },
  methods: {
    async saveItem() {
      this.$validator.reset();
      this.$validator.validateAll();
      let resp = await saveItem(
        this.$route.params.id,
        this.computedFormValues,
        this.$validator
      );
      if (resp.success) {
        this.$root.$notification(resp.message, { type: "success" });
        this.$router.push({ name: "typeCategory.index" });
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
